import { Model } from './model';
import { Fabbricato } from './fabbricato';

export class StatoManutenzione extends Model {
  static apiUrl: string = "stati_manutenzione";

  nome: string;
  fabbricati: Fabbricato[];

  deserialize(input: any): StatoManutenzione {
    let retV: StatoManutenzione = new StatoManutenzione();

    retV = super.deserialize(input) as StatoManutenzione;

    if (input?.fabbricati) {
      retV.fabbricati = input.fabbricati.map(m => new Fabbricato().deserialize(m));
    }

    return retV;
  }

}
